/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

// A set of utility functions for showing toast.

import StringResources from 'nls/StringResources';
import Logger from './Logger';
import Config from '../components/startingPoints/relationshipGraph/Config';

/**
 * Show toast message
 *
 * @param {Object} glassContext - Glass Context
 * @param {String} message - Message of the toast
 * @param {Object} options - Options to override the behavior of the toast.
 */
function _showToast(glassContext, message, options) {
	glassContext.appController.showToast(message, options);
}

/**
 * Show remove styles toast message
 *
 * @param {Object} glassContext - Glass Context
 */

function showRemoveStylesToast(glassContext) {
	_showToast(glassContext, StringResources.get('explore_remove_widget_styles'), {
		type: 'info'
	});
}

/**
 * Show toast message about unsupported data source type on relationship diagram
 *
 * @param {Object} glassContext - Glass Context
 */
function showUnsupportedSourceTypeToast(glassContext) {
	_showToast(glassContext, StringResources.get('startingPoints_unsupported_source_type_toast') ,{
		type: 'info'
	});
}

/**
 * Show toast message about unsupported unenriched package
 *
 * @param {Object} glassContext - Glass Context
 */
function showUnsupportedUnenrichedToast(glassContext) {
	_showToast(glassContext, StringResources.get('startingPoints_unenriched_package_toast') ,{
		type: 'info'
	});
}

/**
 * Show toast message about relationship request timeout
 *
 * @param {Object} glassContext - Glass Context
 */
function showRelationRequestTimeoutToast(glassContext){
	_showToast(glassContext, StringResources.get('startingPoints_relationship_request_timeout'), {
		type:'warning'
	});
}


/**
 * Show toast message about relationship request timeout
 *
 * @param {object} glassContext - Glass Context
 * @param {object} targetModel
 * @param {string} exploreContentViewId content view ID for explore
 */
function showRequestFinishedToast(glassContext, targetModel, exploreContentViewId){
	const contentViewIdsInCache =
		glassContext
			.perspectiveSwitcherRegistry
			.registry
			.map(appView => appView.getCurrentContentView() && appView.getCurrentContentView().id);
	if(exploreContentViewId && contentViewIdsInCache.indexOf(exploreContentViewId) !== -1) {
		const defaultOptions = {
			type:'success',
			timeBeforeDismiss: Config.diagram_request_completed_toast_time_duration
		};

		const currentContentViewId = glassContext.getCurrentContentView() && glassContext.getCurrentContentView().id;
		const isSamePerspective = exploreContentViewId === currentContentViewId;
		const callbackOptions = isSamePerspective ? null : {
			btnLabel: StringResources.get('startingPoints_go_to_diagram'),
			callback: (
				()=>{
					try{
						glassContext.openAppView('explore', { id : exploreContentViewId });
					}catch(exception){
						new Logger().warn(`CA_EXPLORE_REQUEST_FINISH_TOAST_WARN:Unable to open the explore:${exploreContentViewId}`);
					}
				})
		};
		_showToast(
			glassContext,
			`${StringResources.get('startingPoints_diagram_ready', { targetID: targetModel.label } )}`,
			{ ...defaultOptions, ...callbackOptions }
		);
	}
}

/**
 * Show toast message about unsupported unenriched package
 *
 * @param {Object} glassContext - Glass Context
 */
function showUnsupportedExtVisToast(glassContext) {
	_showToast(glassContext, StringResources.get('unsupported_ext_vis_toast') ,{
		type: 'info'
	});
}

export {
	showRemoveStylesToast, showRequestFinishedToast, showUnsupportedSourceTypeToast, showUnsupportedUnenrichedToast, showRelationRequestTimeoutToast, showUnsupportedExtVisToast
};



// WEBPACK FOOTER //
// ./src/js/util/ToastUtil.js